import $ from 'jquery';

const loadTabs = () => {
  // Toggle active class
  $('.vue-tabs li a').on('click', function() {
    $(this).closest('.nav-tabs').find('li').removeClass('active');
    $(this).closest('li').addClass('active');
  });
};

export default loadTabs;
